export default __webpack_public_path__ + "static/media/greyStar.302a0537.svg";